<div
  #mainSize
  class="preview-container">
  <mat-tab-group
    mat-align-tabs="center"
    class="preview"
    (selectedTabChange)="changeOfTab($event.index)">
    <mat-tab>
      <ng-template mat-tab-label>
        <span
          class="material-icons"
          [ngClass]="{ 'tab-selected': selectedTab === 0 }">
          desktop_windows
        </span>
      </ng-template>
      <ng-template matTabContent>
        <div
          class="height"
          [ngStyle]="{ 'max-height': 'calc(100vh - ' + maxHeight + 'px)' }">
          @if (zoomValues['desktop']) {
            <div
              #desktopSize
              class="desktop-preview-frame"
              [ngClass]="{ 'preview-frame': frame, 'mat-elevation-z4': frame }"
              [ngStyle]="{ zoom: zoomValues['desktop'], 'max-width': 1200 + 'px' }">
              <coin-all-cms-news-items
                [highlightItem]="highlightItem"
                [modifiedWidth]="true"
                [isEquityPage]="isEquityPage"
                [authService]="authService"
                [overviewUpdate]="overviewUpdate"
                [heightModified]="heightModified"
                [item]="item"
                [settings]="settings"
                [germanyRowType]="germanyRowType"
                (chapterOverviewClicked)="chapterOverviewClicked()"
                (onItemClicked)="onItemClicked($event)"></coin-all-cms-news-items>
            </div>
          }
        </div>
      </ng-template>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <span
          class="material-icons"
          [ngClass]="{ 'tab-selected': selectedTab === 1 }">
          phone_iphone
        </span>
      </ng-template>
      <ng-template matTabContent>
        <div
          class="height"
          [ngStyle]="{ 'max-height': 'calc(100vh - ' + maxHeight + 'px)' }">
          @if (zoomValues['mobile']) {
            <div
              #mobileSize
              class="mobile-preview-frame"
              [ngStyle]="{ zoom: zoomValues['mobile'] }">
              <coin-all-cms-news-items
                [highlightItem]="highlightItem"
                [modifiedWidth]="true"
                [isEquityPage]="isEquityPage"
                [authService]="authService"
                [overviewUpdate]="overviewUpdate"
                [heightModified]="heightModified"
                [item]="item"
                [settings]="settings"
                [germanyRowType]="germanyRowType"
                (onItemClicked)="onItemClicked($event)"></coin-all-cms-news-items>
            </div>
          }
        </div>
      </ng-template>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <span
          class="material-icons"
          [ngClass]="{ 'tab-selected': selectedTab === 2 }">
          laptop
        </span>
      </ng-template>
      <ng-template matTabContent>
        <div
          class="height"
          [ngStyle]="{ 'max-height': 'calc(100vh - ' + maxHeight + 'px)' }">
          @if (zoomValues['laptop']) {
            <div
              #laptopSize
              class="laptop-preview-frame"
              [ngStyle]="{ zoom: zoomValues['laptop'] }">
              <coin-all-cms-news-items
                [highlightItem]="highlightItem"
                [modifiedWidth]="true"
                [isEquityPage]="isEquityPage"
                [authService]="authService"
                [overviewUpdate]="overviewUpdate"
                [heightModified]="heightModified"
                [item]="item"
                [settings]="settings"
                [germanyRowType]="germanyRowType"
                (onItemClicked)="onItemClicked($event)"></coin-all-cms-news-items>
            </div>
          }
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
